import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';



export function getContableGastoListSuccess(contablegasto) {
  return {type: types.LOAD_CONTABLEGASTO_LIST_SUCCESS, contablegasto};
}



export function getContableGastoList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ContableGastoApi.getContableGastoList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(contablegasto => {                  
                  dispatch(getContableGastoListSuccess(contablegasto));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getContableGastoSuccess(catalogo) {
  return {type: types.LOAD_CONTABLEGASTO_SUCCESS, catalogo};
}

export function getContableGasto(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().ContableGastoApi.getContableGasto(id, token).then(contablegasto => {   
        dispatch(getContableGastoSuccess(contablegasto));
        return contablegasto;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(contablegasto) {
  return {type: types.SAVE_CONTABLEGASTO_SUCCESS, contablegasto};
}


export function save(contablegasto, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().ContableGastoApi.save(contablegasto, token).then(contablegastoGuardado => {   
    dispatch(saveSuccess(contablegastoGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getContableGastoComboSuccess(datos) {
  return {type: types.GET_CONTABLEGASTOS_COMBO_SUCCESS, datos};
}

export function getContableGastoCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().ContableGastoApi.getContableGastoCombo(token).then(datos => {   
        
      dispatch(getContableGastoComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(contablegasto) {
  return {type: types.BORRAR_CONTABLEGASTO_SUCCESS, contablegasto};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ContableGastoApi.borrar(id, token ).then(contablegasto => {
               
                  dispatch(borrarSuccess(contablegasto));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(contablegasto) {
  return {type: types.ACTIVAR_CONTABLEGASTO_SUCCESS, contablegasto};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ContableGastoApi.activar(id, token).then(contablegasto => {
               
                  dispatch(activarSuccess(contablegasto));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_CONTABLEGASTO, filtro};
}



